import { withErrno } from 'kerium';
import { capitalize } from 'utilium/string.js';
import { registerType } from './types.js';
const __view__ = Symbol('DataView');
/**
 * @internal @hidden
 */
function view(buffer) {
    buffer[__view__] ??= new DataView(buffer);
    return buffer[__view__];
}
export { view as __view };
export const types = {
    int8: {
        name: 'int8',
        size: 1,
        array: Int8Array,
        get: (buffer, offset) => view(buffer).getInt8(offset),
        set: (buffer, offset, value) => view(buffer).setInt8(offset, value),
    },
    uint8: {
        name: 'uint8',
        size: 1,
        array: Uint8Array,
        get: (buffer, offset) => view(buffer).getUint8(offset),
        set: (buffer, offset, value) => view(buffer).setUint8(offset, value),
    },
    int16: {
        name: 'int16',
        size: 2,
        array: Int16Array,
        get: (buffer, offset) => view(buffer).getInt16(offset, true),
        set: (buffer, offset, value) => view(buffer).setInt16(offset, value, true),
    },
    uint16: {
        name: 'uint16',
        size: 2,
        array: Uint16Array,
        get: (buffer, offset) => view(buffer).getUint16(offset, true),
        set: (buffer, offset, value) => view(buffer).setUint16(offset, value, true),
    },
    int32: {
        name: 'int32',
        size: 4,
        array: Int32Array,
        get: (buffer, offset) => view(buffer).getInt32(offset, true),
        set: (buffer, offset, value) => view(buffer).setInt32(offset, value, true),
    },
    uint32: {
        name: 'uint32',
        size: 4,
        array: Uint32Array,
        get: (buffer, offset) => view(buffer).getUint32(offset, true),
        set: (buffer, offset, value) => view(buffer).setUint32(offset, value, true),
    },
    int64: {
        name: 'int64',
        size: 8,
        array: BigInt64Array,
        get: (buffer, offset) => view(buffer).getBigInt64(offset, true),
        set: (buffer, offset, value) => view(buffer).setBigInt64(offset, value, true),
    },
    uint64: {
        name: 'uint64',
        size: 8,
        array: BigUint64Array,
        get: (buffer, offset) => view(buffer).getBigUint64(offset, true),
        set: (buffer, offset, value) => view(buffer).setBigUint64(offset, value, true),
    },
    float32: {
        name: 'float32',
        size: 4,
        array: Float32Array,
        get: (buffer, offset) => view(buffer).getFloat32(offset, true),
        set: (buffer, offset, value) => view(buffer).setFloat32(offset, value, true),
    },
    float64: {
        name: 'float64',
        size: 8,
        array: Float64Array,
        get: (buffer, offset) => view(buffer).getFloat64(offset, true),
        set: (buffer, offset, value) => view(buffer).setFloat64(offset, value, true),
    },
};
export const typeNames = Object.keys(types);
for (const t of Object.values(types))
    registerType(t);
export function isTypeName(type) {
    return typeNames.includes(type.toString());
}
export const validNames = [...typeNames, ...typeNames.map(t => capitalize(t)), 'char'];
export function isValid(type) {
    return validNames.includes(type.toString());
}
export function checkValid(type) {
    if (!isValid(type))
        throw withErrno('EINVAL', 'Not a valid primitive type: ' + type);
}
export function normalize(type) {
    return (type == 'char' ? 'uint8' : type.toLowerCase());
}
